import React from 'react';
import { useLabels, usePrefs } from 'wsm-common-data';
import useWindowSticker from '../hooks/useWindowSticker';

const WindowSticker = () => {
	const { windowStickerUrl, isLoading } = useWindowSticker();
	const labels = useLabels();
	const windowStickerLabel = labels.get('WINDOW_STICKER');
	const prefs = usePrefs();
	const showAlternativeHeading = prefs.enableVinStockInHeading === 'true';

	if (isLoading || !windowStickerUrl) {
		return null;
	}

	const handleWindowSticker = () => {
		window.open(windowStickerUrl, '_blank').focus();
	};

	return (
		<React.Fragment>
			{!showAlternativeHeading ? (
				<div className="row">
					<button
						type="button"
						// text-decoration-none is used to remove the underline from the link in some variants
						className="window-sticker-link btn-link text-decoration-none d-flex align-items-center mt-4"
						onClick={handleWindowSticker}
						data-src={windowStickerUrl}
					>
						<i
							className="ddc-icon ddc-icon-document-circle ddc-font-size-large mr-3"
							aria-hidden="true"
							role="presentation"
						/>
						<span className="text-decoration-underline">
							{windowStickerLabel}
						</span>
					</button>
				</div>
			) : (
				<button
					type="button"
					className="window-sticker-link text-nowrap unstyled-button ddc-font-size-xsmall pt-1 text-link"
					onClick={handleWindowSticker}
					data-src={windowStickerUrl}
				>
					<span className="d-flex flex-row align-items-center py-1 px-1">
						<span className="mr-2">{windowStickerLabel}</span>
						<i
							className="pt-2 d-inline-block ddc-icon ddc-icon-launch ddc-icon-size-xlarge"
							aria-hidden="true"
						/>
					</span>
				</button>
			)}
		</React.Fragment>
	);
};

export default WindowSticker;
